<template>
  <div>
    <b-form-group
      v-if="dataItem.id_branches"
      label="Şube Yetkileri"
      label-for="user_branches"
    >
      <b-row id="user_branches">
        <b-col
          v-for="item in branches"
          :key="item.id"
        >
          <b-form-checkbox
            v-model="dataItem.user_branches"
            :value="item.id"
            multiple
            class="text-nowrap mb-1"
            :disabled="item.id === dataItem.id_branches"
          >
            {{ item.title }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>
<script>
import {
  BRow, BCol, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'

export default {
  name: 'UserBranches',
  components: {
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
  },
  computed: {
    branches() {
      return this.$store.getters['branches/dataList']
    },
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
  },
  watch: {
    dataItem: {
      deep: true,
      handler(val) {
        if (val.id_branches) {
          if (!this.dataItem.user_branches.includes(val.id_branches)) {
            this.dataItem.user_branches.push(val.id_branches)
          }
        }
      },
    },
  },
  created() {
    this.getBranches()
  },
  methods: {
    getBranches() {
      this.$store.dispatch('branches/getDataList')
    },
  },
}
</script>
